<h2 mat-dialog-title class="text-align-center"><mat-icon>policy</mat-icon></h2>
<mat-dialog-content>
  <div class="d-flex justify-content-center">
    <mat-spinner *ngIf="!policy"></mat-spinner>
    <div [innerHTML]="policy"></div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close cdkFocusInitial>Close</button>
</mat-dialog-actions>
